import React, { useRef, useEffect, useState } from "react";

const KakaoMapForControl = ({ path, flag }) => {
  const container = useRef(null);
  const [kakaoMap, setKakaoMap] = useState(null);
  const [kakaoPolyline, setKakaoPolyline] = useState(null);
  const [kakaoCustomOverlay, setKakaoCustomOverlay] = useState(null);

  var tmp = [];
  var tmpArray = [];
  useEffect(() => {
    path.map((item, key) => {
      tmp.push(item);
    });
    const script = document.createElement("script");
    script.src =
      "https://dapi.kakao.com/v2/maps/sdk.js?appkey=6b434b80f5b0db49f352c924ce1b60a8&autoload=false";
    document.head.appendChild(script);

    script.onload = () => {
      window.kakao.maps.load(() => {
        // 맵 생성하기
        var center = new window.kakao.maps.LatLng(36.44530132499815, 127.41237631818751);
        if (path.length != 0) {
          center = new window.kakao.maps.LatLng(path[0].Ma, path[0].La);
        }
        const options = {
          center,
          level: 5
        };
        let map;
        if (kakaoMap === null) {
          map = new window.kakao.maps.Map(container.current, options);
          setKakaoMap(map);
        } else {
          map = kakaoMap;
        }
        console.log('path changed!');

        // prop: path 로 선 객체 만들기
        var lineTMP = [];
        for (var i = 0; i < path.length; i++) {
          lineTMP.push(new window.kakao.maps.LatLng(path[i]["Ma"], path[i]["La"]));
        }
        if (kakaoPolyline !== null) {
          kakaoPolyline.setMap(null);
        }
        var polyline = new window.kakao.maps.Polyline({
          path: lineTMP, // 선을 구성하는 좌표배열 입니다
          strokeWeight: 5, // 선의 두께 입니다
          strokeColor: '#FF0000', // 선의 색깔입니다
          strokeOpacity: 0.6, // 선의 불투명도 입니다 1에서 0 사이의 값이며 0에 가까울수록 투명합니다
          strokeStyle: 'solid' // 선의 스타일입니다 
        });

        polyline.setMap(map);
        setKakaoPolyline(polyline);

        if (kakaoCustomOverlay !== null) {
          kakaoCustomOverlay.map((item, key)=>{
            item.setMap(null);
          })
        }

        path.map((item, key) => {
          if (key % flag !== 0) {
            return;
          }
          var content = `<div><span class="center" style="background-color: white; border-radius: 30px;">${key + 1}</span></div>`;
          var position = new window.kakao.maps.LatLng(path[key]["Ma"], path[key]["La"]);
          var customOverlay = new window.kakao.maps.CustomOverlay({
            position: position,
            content: content
          });
          tmpArray.push(customOverlay);
        });

        tmpArray.map((item, key) => {
          item.setMap(map);
        });

        setKakaoCustomOverlay(tmpArray);
      });
    };
  }, [container, path, flag]);
  return (
    <div id="container" ref={container} style={{ width: "100%", height: "500px" }} />
  );
}

export default KakaoMapForControl;